import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Invalid email or password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <form style={s.card} onSubmit={handleLogin}>
        <div style={s.logo}>
          <img src="/assets/logo.png" alt="MacroMatrix" style={{ width: 52, borderRadius: 14 }} />
        </div>
        <h1 style={s.title}>Admin Login</h1>
        <p style={s.sub}>MacroMatrix Content Dashboard</p>

        {error && <div style={s.err}>{error}</div>}

        <label style={s.label}>Email</label>
        <input
          style={s.input}
          type="email"
          placeholder="admin@macromatrix.io"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoFocus
        />

        <label style={s.label}>Password</label>
        <input
          style={s.input}
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <button style={loading ? { ...s.btn, opacity: 0.7 } : s.btn} disabled={loading}>
          {loading ? 'Signing in…' : 'Sign In'}
        </button>
      </form>
    </div>
  );
};

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg,#0f172a,#1e293b)',
    fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',
  },
  card: {
    background: '#1e293b',
    border: '1px solid #334155',
    borderRadius: 20,
    padding: '40px 36px',
    width: '100%',
    maxWidth: 420,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    boxShadow: '0 24px 64px rgba(0,0,0,0.4)',
  },
  logo: { display: 'flex', justifyContent: 'center', marginBottom: 4 },
  title: { margin: 0, color: '#f1f5f9', fontSize: 24, fontWeight: 700, textAlign: 'center' },
  sub: { margin: '0 0 8px', color: '#64748b', fontSize: 13, textAlign: 'center' },
  err: { background: '#7f1d1d', color: '#fca5a5', padding: '10px 14px', borderRadius: 10, fontSize: 13 },
  label: { color: '#94a3b8', fontSize: 13, fontWeight: 600 },
  input: {
    padding: '11px 14px',
    borderRadius: 10,
    border: '1.5px solid #334155',
    background: '#0f172a',
    color: '#f1f5f9',
    fontSize: 15,
    outline: 'none',
  },
  btn: {
    marginTop: 8,
    padding: '13px',
    borderRadius: 12,
    border: 'none',
    background: 'linear-gradient(135deg,#14c9b2,#7c5cbf)',
    color: '#fff',
    fontWeight: 700,
    fontSize: 15,
    cursor: 'pointer',
  },
};

export default LoginPage;
